"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconGlobe', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M10,1a9,9,0,1,0,9,9A9,9,0,0,0,10,1Zm7,8.25H14.73a12.91,12.91,0,0,0-1.3-5.34A7,7,0,0,1,17,9.25Zm-6.08,7.69-.13,0V10.75h2.48C13.08,13.84,12,16.14,10.88,16.94ZM6.77,10.75H9.25V17l-.13,0C8,16.14,6.92,13.84,6.77,10.75ZM9.12,3.06l.13,0V9.25H6.77C6.92,6.16,8,3.86,9.12,3.06Zm1.63,6.19V3l.13,0c1.15.8,2.2,3.1,2.35,6.19ZM6.57,3.91a12.91,12.91,0,0,0-1.3,5.34H3A7,7,0,0,1,6.57,3.91ZM3,10.75H5.27a12.91,12.91,0,0,0,1.3,5.34A7,7,0,0,1,3,10.75Zm10.39,5.34a12.91,12.91,0,0,0,1.3-5.34H17A7,7,0,0,1,13.43,16.09Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;